import {
  getCarBrandLabel,
  isValidCarBrandSlug,
} from "../constants/carBrands";

const CAR_LOGO_CDN_BASE =
  "https://cdn.jsdelivr.net/gh/filippofilip95/car-logos-dataset@master/logos/thumb";

const MOTO_LOGO_CDN_BASE =
  "https://cdn.jsdelivr.net/gh/javimogan/vehicle-logos-dataset@main/logos/rounds";

/** Brands whose logos come from the motorcycle dataset (not car-logos-dataset). */
const MOTO_LOGO_BRAND_SLUGS = new Set([
  "aprilia",
  "ducati",
  "harley-davidson",
  "honda-moto",
  "kawasaki",
  "vespa",
  "yamaha",
]);

/** When the stored slug differs from the image filename in the logo dataset. */
const LOGO_SLUG_OVERRIDES: Record<string, string> = {
  "honda-moto": "honda",
  gwm: "great-wall",
};

export function getCarBrandSlug(brand?: string | null): string | null {
  if (!brand?.trim()) {
    return null;
  }

  const slug = brand.trim().toLowerCase();
  return isValidCarBrandSlug(slug) ? slug : null;
}

export function getCarLogoUrl(brand?: string | null): string | null {
  const slug = getCarBrandSlug(brand);
  if (!slug) {
    return null;
  }

  const imageSlug = LOGO_SLUG_OVERRIDES[slug] ?? slug;

  if (MOTO_LOGO_BRAND_SLUGS.has(slug)) {
    return `${MOTO_LOGO_CDN_BASE}/${imageSlug}.png`;
  }

  return `${CAR_LOGO_CDN_BASE}/${imageSlug}.png`;
}

export { getCarBrandLabel };
